import { Space } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SSpace = styled(Space)``;
